import styled from '@emotion/styled';
import { colors } from 'theme/colors';

export const StyledFormWarningLabel = styled.label`
  min-height: 16px;
  margin-bottom: 4px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${colors.warning800};
`;
